import { Injectable } from '@angular/core';
import { Purpose } from '../models/new/purpose';
import { Warehouse } from 'src/app/shared/types/warehouse.model';

@Injectable({
	providedIn: 'root'
})
export class WarehouseMapper {
	constructor() {}

	toWarehouse(warehouse: any) {
		return new Warehouse({
			id: warehouse.id,
			code: warehouse.code,
			description: warehouse.description
		});
	}
}
